import depotMarker from '@assets/CustomIcons/depot-pin-shadow.png'
import storeMarker from '@assets/CustomIcons/store-pin-shadow.png'
import terminalMarker from '@assets/CustomIcons/terminal-pin-shadow.png'
import routeArrow0 from '@assets/CustomIcons/route-arrow-0.png'
import routeArrow1 from '@assets/CustomIcons/route-arrow-1.png'
import routeArrow2 from '@assets/CustomIcons/route-arrow-2.png'
import routeArrow3 from '@assets/CustomIcons/route-arrow-3.png'
import routeArrow4 from '@assets/CustomIcons/route-arrow-4.png'
import routeArrow5 from '@assets/CustomIcons/route-arrow-5.png'
import loadArrivalIcon from '@assets/CustomIcons/load-arrive-shadow.png'
import loadDepartIcon from '@assets/CustomIcons/load-depart-shadow.png'
import dropArrivalIcon from '@assets/CustomIcons/drop-arrive-shadow.png'
import dropDepartIcon from '@assets/CustomIcons/drop-depart-shadow.png'
import loadMarker from '@assets/CustomIcons/load_marker.png'
import dropMarker from '@assets/CustomIcons/drop_marker.png'

import type * as turf from '@turf/turf'
import type { MapFilters, MapSettings } from './types'

export const MAP_IMAGES = [
  {
    name: 'depots-marker',
    url: depotMarker,
  },
  { name: 'sites-marker', url: storeMarker },
  { name: 'terminals-marker', url: terminalMarker },
  { name: 'route-arrow-0', url: routeArrow0 },
  { name: 'route-arrow-1', url: routeArrow1 },
  { name: 'route-arrow-2', url: routeArrow2 },
  { name: 'route-arrow-3', url: routeArrow3 },
  { name: 'route-arrow-4', url: routeArrow4 },
  { name: 'route-arrow-5', url: routeArrow5 },
  { name: 'load-arrival-icon', url: loadArrivalIcon },
  { name: 'load-depart-icon', url: loadDepartIcon },
  { name: 'drop-arrival-icon', url: dropArrivalIcon },
  { name: 'drop-depart-icon', url: dropDepartIcon },
  { name: 'load-marker', url: loadMarker },
  { name: 'drop-marker', url: dropMarker },
]

export const ROUTE_COLORS = ['#4285F4', '#3F63C0', '#14248A', '#36C967', '#2FA65A', '#10641D']
export const ROUTE_ARROWS = [
  'route-arrow-0',
  'route-arrow-1',
  'route-arrow-2',
  'route-arrow-3',
  'route-arrow-4',
  'route-arrow-5',
]

export const OFFLINE_THRESHOLD = 5 // minutes

export const TURF_OPTIONS = { steps: 64, units: 'miles' as turf.Units }

export const DEFAULT_VIEW_STATE = {
  longitude: -98.5795,
  latitude: 39.828175,
  zoom: 4,
}

export const ICON_SIZES = {
  small: {
    icon: 16,
    container: 20,
  },
  medium: {
    icon: 20,
    container: 26,
  },
  large: {
    icon: 24,
    container: 32,
  },
} as const

export const MAP_STYLE_OPTIONS = {
  default: {
    sd_light: 'mapbox://styles/hostmaster-gravitate/cmeki17vh006i01rkgph76yx8',
    sd_dark: 'mapbox://styles/hostmaster-gravitate/cmenh2993009n01si7sz2gmod',
  },
  satellite: 'mapbox://styles/hostmaster-gravitate/cmenh3a8q00mm01r9fnld2xay',
} as const

export const DEFAULT_MAP_FILTERS: MapFilters = {
  sites: {
    counterparty_name: [],
    customer: [],
    sector: [],
    state: [],
    city: [],
    postal_code: [],
  },
  terminals: {
    sector: [],
    state: [],
    city: [],
    postal_code: [],
  },
  depots: {
    sector: [],
    state: [],
    city: [],
    postal_code: [],
  },
} as const

export const DEFAULT_MAP_SETTINGS: MapSettings = {
  style: 'default', // or whatever your default style is
  showBreadcrumbs: false,
  showLocations: 'all',
}
